

import Panels from './Panels';
// import Schools from './Schools';
import ModalHeader from '../components/ModalHeader';
import useAuth from '../hooks/useAuth';



const colors =
{
    app_brown: '#f07e64',
    app_red: '#e35972',
    app_green: '#6fa84a',
    app_green_light: '#93BC78',
    app_yellow: '#f2c237',
    app_blue: '#49a3d4',
    app_blue_dark: '#136492',
    app_dark_green: '#098C5E',
}

function SelectionPage() {
    const { isAuthenticated, logout, user } = useAuth();
    return (
        <div className="flex flex-col justify-between bg-white ">
            
           
            <ModalHeader title="Διαλογή στην Πηγή" subtitle="Κερδίζω όσο Διαχωρίζω"></ModalHeader>

            <div className='items-center justify-between px-4 mx-auto lg:flex lg:px-0 max-w-[1200px] mb-8 mt-3 '>
            {/* <h3 className="flex justify-center w-auto text-xl font-semibold text-app_green_light bg-app_yellow">
            Διαλέξτε Λειτουργία
                </h3> */}
                {/* <div className="text-white bg-gradient-to-r from-app_green to-app_blue   font-bold rounded-full text-2xl px-10 py-4 text-center">Διαλέξτε Λειτουργία</div> */}
            
                <div  
                onClick={() => {
                    logout()
                }}
                className="cursor-pointer ml-3 flex text-gray-400 shadow-md  font-bold rounded-full text-lg px-10 py-2 text-center">
                    Αποσύνδεση
                </div>
            
            </div>

            

            

            

            <Panels></Panels>


            <div className="text-center text-sm bottom-0 w-full h-5 lg:fixed bg-gradient-to-r from-app_green to-app_blue">
                    

            </div>

            {/* <DataTable></DataTable> */}


        </div>
    );
}

export default SelectionPage;
